import { computed, ref } from "vue";
import { SearchResult } from "@modules/resource-search/resource-search-types.ts";
import { isEmpty } from "@utils/var.check.ts";
import { useI18n } from "vue-i18n";
import { SEARCH_RESULT_PAGE_SIZE } from "@modules/resource-search/resource-search-helper.ts";

export function useSearchResult(pageSizeData?: number) {
  const { t } = useI18n();
  //Data
  const isLoading = ref(true);
  const pageNo = ref<number>(1);
  const pageSize = ref<number>(pageSizeData ?? SEARCH_RESULT_PAGE_SIZE);
  const searchResult = ref<SearchResult>({
    draw: 0,
    recordsTotal: 0,
    recordsFiltered: 0,
    length: 0,
    start: 0,
    error: null,
    data: [],
  });

  // Computed
  const resultList = computed(() => {
    return searchResult.value?.data ?? [];
  });

  const isEmptySearchResult = computed(() => resultList.value.length === 0);

  const disableForwardsButton = computed(() => {
    if (searchResult.value) {
      //calculate last page number
      const endPageIdx = Math.ceil(searchResult.value?.recordsTotal / Math.max(pageSize.value, 1));
      return pageNo.value === endPageIdx;
    }
    return true;
  });

  const disableBackwardsButton = computed(() => {
    if (isLoading.value || !searchResult.value || isEmpty(resultList.value)) {
      return true;
    }
    return searchResult.value?.start === 0;
  });

  const totalRecordLabel = computed(() =>
    t("search_result_total_record_label", {
      count: searchResult.value?.recordsTotal ?? 0,
    }),
  );

  const resetSearchData = () => {
    searchResult.value = {
      draw: 0,
      recordsTotal: 0,
      recordsFiltered: 0,
      length: 0,
      start: 0,
      error: null,
      data: [],
    };
  };

  return {
    isLoading,
    pageNo,
    pageSize,
    searchResult,
    resultList,
    isEmptySearchResult,
    disableForwardsButton,
    disableBackwardsButton,
    totalRecordLabel,
    resetSearchData,
  };
}
